import { Component } from '@angular/core';
import { MessageService as PrimeMessageService } from 'primeng/api';
import { MessageService } from '../../services/message.service';


@Component({
    selector: 'message',
	templateUrl: './message.component.html',
	styleUrls: ['./message.component.scss']
})
export class MessageComponent {

	public show: boolean;

	public message: string;
	public get hasMessage(): boolean {
		return !!this.message;
	}

	public growlMessage: any[];

	public working: boolean;

	constructor(/*private messageService: PrimeMessageService,*/ private uvMessageService: MessageService) {
		this.setupWorking();

		uvMessageService.onWorkingChanged.subscribe(
			(newWorking: number) => {
				this.setupWorking();
			});

		//setInterval(() => console.log(`working: ${this.working}`), 5000);
	}
	
	private setupWorking(): void {
		this.working = (this.uvMessageService.working > 0);
	}

}